import { T } from '@tolgee/react';

const DistributorBanner = () => {
  return (
    <div className="bg-gradient-to-r from-yellow-400 to-yellow-500 text-black py-3 px-4">
      <div className="max-w-7xl mx-auto flex items-center justify-center">
        <div className="flex items-center space-x-3">
          {/* Icono de distribuidor */}
          <div className="flex-shrink-0">
            <svg 
              className="w-6 h-6" 
              fill="currentColor" 
              viewBox="0 0 20 20"
            >
              <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z" />
            </svg>
          </div>
          
          {/* Texto del banner */}
          <div className="text-center">
            <p className="font-bold text-lg leading-tight">
              <T keyName="distributor.banner.title">ZONA EXCLUSIVA PARA DISTRIBUIDORES Y MAYORISTAS</T>
            </p>
            <p className="text-sm font-medium opacity-90">
              <T keyName="distributor.banner.subtitle">Acceso restringido a profesionales del sector</T>
            </p>
          </div>
          
          {/* Icono de candado */}
          <div className="flex-shrink-0">
            <svg 
              className="w-6 h-6" 
              fill="currentColor" 
              viewBox="0 0 20 20"
            >
              <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DistributorBanner;
